import React, { Fragment } from 'react';

const General = () => {
    return <Fragment>
        
    </Fragment>
}
export default General;

//Map here